import create from 'zustand'
import { persist } from 'zustand/middleware'
/*//@ts-ignore
const [showWizardStore] = create(persist(set => ({
  show: { dashboard: true },
  setShow: (dashboard) => {
    set({ show: {dashboard : dashboard}});
  },
  clearShow : () => set({show : { dashboard : false}})
}),{
    name: "showWizardStorev3"
}
))

export default showWizardStore; */

const TOUR_KEYS = {
  SELLER: 'sellerTour',
  BUYER: 'buyerTour',
  NEW_COMPANY_PROMPT: 'newCompanyPromptTour', // Nuevo tour para MyStore
};

const useShowWizardStore = create( 
  persist(
    (set) => ({
      // 1. Estado inicial con ambos flags
      show: {
        [TOUR_KEYS.SELLER]: true, 
        [TOUR_KEYS.BUYER]: true, 
        [TOUR_KEYS.NEW_COMPANY_PROMPT]: true, // Estado inicial para el nuevo tour 
      },

      // 2. Función modificada para actualizar un tour específico por su clave
      setShowTour: (tourKey, value) => {
        set((state) => ({
          show: {
            ...state.show,  
            [tourKey]: value, 
          },
        }));
      },

      // 3. Función modificada para limpiar/resetear todos los tours conocidos
      clearAllTours: () =>
        set({
          show: {
            [TOUR_KEYS.SELLER]: false,
            [TOUR_KEYS.BUYER]: false,
            [TOUR_KEYS.NEW_COMPANY_PROMPT]: false,
          },
        }),

    }),
    {
      name: 'showWizardStorev3', 
    }
  )
);

// Exporta las claves 
export { TOUR_KEYS };

export default useShowWizardStore;
